module.exports = __webpack_public_path__ + "static/media/stijn-bessem-testimonials-brian@2x.ec4ae03f.jpg";